import { useEffect, useState } from "react";
import React from 'react';
import { useNavigate, Link } from "react-router-dom"; 
import { getCircular } from "../Service/Api";
import LazyLoad from 'react-lazyload';
import Header from '../Component/Header';
import Footer from '../Component/Footer';  
function Circular() { 
  useEffect(() => {
    document.title = 'Circular -  Mercy Memorial School, Kanpur';  
}, []); 
const navigate = useNavigate()
const [data, setData] = useState([]);
const [filterData, setFilteredData] = useState([]);
const [selectedYear, setSelectedYear] = useState();
const [selectedMonth, setSelectedMonth] = useState("All"); 
const [yearRanges, setYearRanges] = useState([]);
const [searchQuery, setSearchQuery] = useState("");
const [monthOptions, setMonthOptions] = useState(["All", "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]);
const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

useEffect(() => {
    const currentYear = new Date().getFullYear();
    const Year = `${currentYear}`;
    setSelectedYear(Year);
    
 }, []);

useEffect(() => {
    const fetchData = async () => {
        const circularData = await getCircular();
        
        setData(circularData);
    };
    fetchData();
}, []);

useEffect(() => {
    if(!data) {
        return;
    }
    console.log(selectedMonth, selectedYear, searchQuery);
    let filteredData = data;
    if (selectedYear !== "All") {
        filteredData = filteredData.filter((item) => {
            if (item.date && item.date.trim() !== "") {
                const year = new Date(item.date).getFullYear();
                const month = new Date(item.date).getMonth() + 1;
                return parseInt(selectedYear) === year && (selectedMonth === "All" || parseInt(selectedMonth) === month);
            } else {
                return false;
            }
        });
    }
    if (selectedMonth !== "All") {
        filteredData = filteredData.filter((item) => {
            if (item.date && item.date.trim() !== "") {
                const month = new Date(item.date).getMonth() + 1;
                return parseInt(selectedMonth) === month;
            } else {
                return false;
            }
        });
    }
    if (searchQuery) {
        filteredData = filteredData.filter((item) =>
            item.title.toLowerCase().includes(searchQuery.toLowerCase())
        );
    }
    setFilteredData(filteredData);
    const datas = filteredData.filter((div) => div.category === "Circular");
    setFilteredData(datas);
}, [selectedYear, selectedMonth, searchQuery, data]);

useEffect(() => {
    console.log('filterData', filterData)
}, [filterData]);



const emptyArray = [
    {title:"Circular Title",description:"Stay Tunned For More Updates",day:"DD",month:"MM"},
    {title:"Circular Title",description:"Stay Tunned For More Updates",day:"DD",month:"MM"}
   ];
  return (
    <>   
      <Header />
      <div className="sliderbg"></div>
      <div className="innerpage">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <ul className="breadcrumbli">
                <li><Link to="/"> Home </Link></li> 
                <li>Circular</li>
              </ul>
            </div> 
            <div className="col-lg-12">
              <h2 className="innerheading">Circular</h2>
            </div>
          </div> 
          <div className="row tabs-dynamic"> 
          <div className="col-md-3">
              <div className="month-selection">
                  <select id="yearSelection" onChange={(e) => setSelectedYear(e.target.value)} value={selectedYear}>
                      <option value="All">All Years</option>
                      {yearRanges.map((yr, index) => (
                          <option key={index} value={yr}>{yr}</option>
                      ))}
                  </select>
              </div>
          </div> 
          <div className="col-md-3">
              <div className="searchBox">
                  <input 
                      type="text" 
                      id="myInput" 
                      name="name" 
                      autoComplete="off" 
                      placeholder="Search Here.." 
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                  />
              </div>
          </div>
      </div>
                    <div className="row">
                    {filterData?.length > 0 ? filterData?.filter((item) =>  item.category === "Circular").map((item, index) => (
                    
                        <div className="col-lg-4" key={index}> 
                        <Link to={`https://webapi.entab.info/api/image/${item?.attachments[0]}`} target="_blank">
                            <div className="sample-blk">
                              <div>
                                   <p> {item.title}</p>
                                  <span>{item.date}</span>
                              </div> 
                              <LazyLoad><img alt="MMSKN" src="https://webapi.entab.info/api/image/MMSKN/public/Images/pdf.png" className="img-fluid"/> 
                              </LazyLoad>
                              </div> 
                           </Link>
                    </div>
                    ))
                : (
                    <div className="col-lg-4"> 
                    <a href="#" target="_blank"> 
                        <div className="sample-blk">
                          <div>
                               <p> Title</p>
                              <span>DD.MM.YY</span>
                          </div> 
                          <LazyLoad> <img alt="MMSKN" src="https://webapi.entab.info/api/image/MMSKN/public/Images/pdf.png" className="img-fluid"/>
                          </LazyLoad>
                           </div> 
                    </a>  
                </div>
                  )}
                    </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default Circular;
